import { DEMO_DIFFUSION_FLUX, DEMO_DIFFUSION_ETATS, DEMO_OEUVRES } from './demoFixtures.js';
import type { CorpsFlux } from './diffusion.js';

// reponseDemo ne dessert que Sainte-Avoye : cet état ne peut pas toucher une autre galerie.
const flux = structuredClone(DEMO_DIFFUSION_FLUX);
export function reponseDemoDiffusion(
  chemin: string,
  params: URLSearchParams,
  methode: string,
  corps?: unknown,
): unknown | undefined {
  if (chemin === '/diffusion/flux' && methode === 'GET')
    return { flux: structuredClone(flux), eligibles: 17 };
  const oeuvre = /^\/diffusion\/oeuvres\/([^/]+)$/.exec(chemin);
  if (oeuvre && methode === 'GET')
    return {
      etats: DEMO_DIFFUSION_ETATS.filter((e) => e.oeuvreId === oeuvre[1]),
      choisiePar: flux
        .filter((f) => f.oeuvresChoisies.includes(oeuvre[1]!))
        .map((f) => f.plateforme),
    };
  if (chemin === '/diffusion/oeuvres' && methode === 'GET')
    return {
      oeuvres: DEMO_DIFFUSION_ETATS.filter((e) => e.plateforme === params.get('plateforme')),
    };
  const route = /^\/diffusion\/flux\/(artsy|artnet)(.*)$/.exec(chemin);
  if (!route) return undefined;
  const f = flux.find((f) => f.plateforme === route[1])!;
  const suite = route[2];
  if (!suite && methode === 'GET')
    return {
      flux: structuredClone(f),
      compteurs:
        f.plateforme === 'artsy'
          ? { en_attente: 0, diffusee: 12, refusee: 2, retiree: 3 }
          : { en_attente: 0, diffusee: 0, refusee: 0, retiree: 0 },
    };
  if (!suite && methode === 'PATCH') {
    const c = corps as CorpsFlux;
    if (c.revision !== f.revision) throw new Error('La révision a changé.');
    for (const cle of ['actif', 'toutesLesEligibles', 'langue'] as const)
      if (c[cle] !== undefined) Object.assign(f, { [cle]: c[cle] });
    f.revision++;
    return { flux: structuredClone(f) };
  }
  const choix = /^\/oeuvres\/([^/]+)$/.exec(suite!);
  if (choix && methode === 'PUT') {
    const choisie = (corps as { choisie: boolean }).choisie;
    f.oeuvresChoisies = choisie
      ? [...new Set([...f.oeuvresChoisies, choix[1]!])]
      : f.oeuvresChoisies.filter((id) => id !== choix[1]);
    f.revision++;
    return { flux: structuredClone(f) };
  }
  if (suite === '/apercu' && methode === 'GET')
    return {
      oeuvres: [],
      refusees:
        f.plateforme === 'artsy'
          ? DEMO_DIFFUSION_ETATS.filter((e) => e.etat === 'refusee').map((e) => ({
              oeuvreId: e.oeuvreId,
              titre: DEMO_OEUVRES.find((o) => o.id === e.oeuvreId)!.titre,
              motifs: e.erreurs,
            }))
          : [],
    };
  if (suite === '/synchroniser' && methode === 'POST') return { demande: true };
  if (suite === '/lien' && methode === 'POST') {
    f.lien = true;
    f.lienCreeLe = new Date().toISOString();
    // URL fictive non persistée, créée dans la réponse uniquement.
    return { lien: { url: 'https://demo.example.invalid/flux/artsy', creeLe: f.lienCreeLe } };
  }
  return undefined;
}
